import { CheckCircle, Pencil, X } from "lucide-react";
import { Setting } from "../../services/user.service";

type OrderStatusProps = {
  status: string
  list?: Setting[]
}

export const OrderStatusHelper = ({ status, list }: OrderStatusProps) => {
  const setting = list?.find((setting) => setting.code === status)

  return (
    <span className={`delivery_status px-2.5 py-0.5 text-xs inline-block font-medium rounded border ${setting?.class}`}>
      {setting?.value || status}
    </span>
  )
}

export const PaymentStatusHelper = ({ status }: { status: string }) => {
  switch (status) {
    case "paid":
      return (
        <span className="px-2.5 py-0.5 text-xs font-medium rounded border bg-green-100 border-transparent text-green-500 dark:bg-green-500/20 dark:border-transparent inline-flex items-center status">
          <CheckCircle className="w-3 h-3 mr-1.5" />{status}
        </span>
      )
    case "unpaid":
      return (
        <span className="px-2.5 py-0.5 inline-flex items-center text-xs font-medium rounded border bg-red-100 border-transparent text-red-500 dark:bg-red-500/20 dark:border-transparent status">
          <X className="w-3 h-3 mr-1.5" />{status}
        </span>
      )
    default:
      return (
        <span className="px-2.5 py-0.5 text-xs font-medium rounded border bg-green-100 border-transparent text-green-500 dark:bg-green-500/20 dark:border-transparent inline-flex items-center status">
          <CheckCircle className="w-3 h-3 mr-1.5" />{status || '-'}
        </span>
      )
  }
}

export const StatusHelper = ({ status }: { status: string }) => {
  switch (status) {
    case "active":
      return (
        <span className="px-2.5 py-0.5 text-xs font-medium rounded border bg-green-100 border-transparent text-green-500 dark:bg-green-500/20 dark:border-transparent inline-flex items-center status">
          <CheckCircle className="w-3 h-3 mr-1.5" />{status}
        </span>
      )
    case "inactive":
      return (
        <span className="px-2.5 py-0.5 inline-flex items-center text-xs font-medium rounded border bg-red-100 border-transparent text-red-500 dark:bg-red-500/20 dark:border-transparent status">
          <X className="w-3 h-3 mr-1.5" />{status}
        </span>
      )
    case "draft":
      return (
        <span className="px-2.5 py-0.5 text-xs font-medium rounded border bg-gray-100 border-transparent text-gray-500 dark:bg-gray-500/20 dark:border-transparent inline-flex items-center status">
          <Pencil className="w-3 h-3 mr-1.5" />{status}
        </span>
      )
    default:
      return (
        <span className="px-2.5 py-0.5 text-xs font-medium rounded border bg-green-100 border-transparent text-green-500 dark:bg-green-500/20 dark:border-transparent inline-flex items-center status">
          <CheckCircle className="w-3 h-3 mr-1.5" />{status || '-'}
        </span>
      )
  }
}